'use client'

import { useState } from 'react';

export default function BloccoAccettazione({ cliente }) {
  const [scelta, setScelta] = useState(
    cliente.is_declined ? 'no' : cliente.numero_partecipanti ? 'si' : null
  );

  const [partecipanti, setPartecipanti] = useState(cliente.numero_partecipanti || null);
  const [confermato, setConfermato] = useState(
    cliente.is_declined || cliente.numero_partecipanti > 0
  );

  const numeroMax = cliente?.numero_invitati || 1;

  const handleInviaNp = async () => {
    try {
      await fetch(`https://apimoretti.devb01.it/api/customers/token/${cliente.codice_invito}/decline`, {
        method: 'PUT',
      });
      setScelta('no');
      setConfermato(true);
    } catch (error) {
      console.error('Errore nel rifiuto:', error);
    }
  };

  const handleInvia = async (numero) => {
    if (!numero || numero > numeroMax) return;

    try {
      await fetch(`https://apimoretti.devb01.it/api/customers/token/${cliente.codice_invito}/accept`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ numero_partecipanti: numero }),
      });

      setPartecipanti(numero);
      setConfermato(true);
    } catch (error) {
      console.error('Errore nel salvataggio della partecipazione:', error);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 w-full mt-20 mx-auto space-y-6 text-center">
      <h2 className="text-2xl font-medium text-black">{`Gentile`}<br /> <span className='text-3xl font-bold'>{cliente.azienda}</span></h2>
      <p className="text-2xl mt-4 mb-4 text-black text-2xl">Unisciti a noi per la Yellow Night <br />un evento esclusivo per amici e clienti speciali!</p>
<br />
      <button
        onClick={() => {
          setScelta(null);
          setPartecipanti(null);
          setConfermato(false);
        }}
        className="bg-[#FFD500] hover:bg-yellow-700 text-black font- py-10 font-bold px-16 text-2xl uppercase rounded-full shadow transition cursor-pointer"
      >
        Sarai dei nostri?
      </button>

      {scelta === null && (
        <div className="space-y-4 pt-4">
          <button
            onClick={handleInviaNp}
            className="w-full bg-black hover:bg-gray-300 text-[#FFD500] py-6 px-4  uppercase text-2xl  font-bold rounded-full cursor-pointer"
          >
            Mi dispiace, non posso
          </button>
          <button
            onClick={() => setScelta('si')}
            className="w-full bg-[#FFD500] hover:bg-[#95BE32] text-black py-6 px-4 text-2xl  uppercase font-bold rounded-full cursor-pointer"
          >
            Certo, parteciperò alla Yellow Night
          </button>
        </div>
      )}

      {scelta === 'no' && (
        <p className="text-gray-600 pt-4 text-2xl">Grazie comunque! Ci mancherai 💛</p>
      )}

      {scelta === 'si' && !confermato && cliente?.numero_invitati > 1 && (
        <div className="pt-4 space-y-4">
          <p className="text-sm text-gray-700 font-medium text-2xl">Quante persone sarete? (max {numeroMax})</p>
          <div className="flex flex-wrap justify-center gap-2">
            {[...Array(numeroMax)].map((_, i) => {
              const numero = i + 1;
              return (
                <button
                  key={numero}
                  onClick={async () => {
                    setPartecipanti(numero);
                    await handleInvia(numero);
                  }}
                  className={`px-4 py-2 rounded-full border ${
                    partecipanti === numero
                      ? 'bg-[#FFD500] text-black font-bold '
                      : 'bg-[#FFD500] text-black font-bold hover:bg-gray-300 cursor-pointer'
                  }`}
                >
                  {numero}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {scelta === 'si' && !confermato && cliente?.numero_invitati === 1 && (
        <div className="pt-4 space-y-4">
          <p className="text-sm text-gray-700 font-medium">Sarai presente?</p>
          <button
            onClick={() => {
              setPartecipanti(1);
              handleInvia(1);
            }}
            className="bg-black text-[#FFD500] hover:bg-gray-800 text-2xl font-semibold py-2 px-6 rounded-full shadow transition"
          >
            Conferma la tua partecipazione
          </button>
        </div>
      )}

      {confermato && scelta && (
        <p className="text-black font-semibold pt-4">
          Hai già {scelta === 'si' ? `confermato ${partecipanti} partecipant${partecipanti > 1 ? 'i' : 'e'}` : 'declinato l\'invito '} alla <b>Yellow Night</b>.<br />
          Se desideri, puoi modificare la tua scelta.
        </p>
      )}
    </div>
  );
}
